import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { Modal, Button, Table } from "react-bootstrap";
import { API_BASE_URL } from "../../config";

const LoanPOPUP = ({fetchfirstdata,savedData}) => {
  const { logout } = useAuth();
  const [calculator, setCalculator] = useState({
    token: localStorage.getItem("authToken"),
    name: "",
    amount: "",
    type: "Outside"
  });

  const [showLoanPOPUP, setShowLoanPOPUP] = useState(false);
  
  const navigate = useNavigate(); // Call useNavigate to get navigate function
  // Load data from localStorage on component mount
  useEffect(() => {

  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    //setCalculator({ ...calculator, [name]: value });
    setCalculator((prev) => ({
        ...prev,
        [name]: value,
    }));
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');      


    try {
      const response = await axios.post(`${API_BASE_URL}/api/loansave`,
        calculator,
        {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      setSuccess('Item added successfully!');
      //window.location.reload();
      setLoading(false);

      // Clear form after successful submission
      //setCalculator({ name: '', amount: ''});
      setCalculator((prev) => ({
        token: prev.token, // Preserve the token
        name: '',
        amount: '',
      }));
      fetchfirstdata();

    } catch (error) {
      logout();
      navigate('/'); // Use navigate to redirect
    }
  };

  const handleOpenLoanPOPUP = () => setShowLoanPOPUP(true);
  const handleCloseLoanPOPUP = () => setShowLoanPOPUP(false);



  return (
    <div className="money_counter">
      <span className="bt-calculeter" onClick={handleOpenLoanPOPUP}>
        Add New
      </span>

      <Modal show={showLoanPOPUP} onHide={handleCloseLoanPOPUP}>
        <Modal.Header closeButton>
          <Modal.Title>Money Counter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row top-aj">
            <div className="form-group col-12">
                <input
                type="number"
                name="amount"
                className="form-control"
                placeholder="amount"
                value={calculator.amount}
                onChange={handleChange}
                required
                />
            </div>
            <div className="form-group col-12">
                <input
                type="text"
                name="name"
                className="form-control"
                placeholder="name"
                value={calculator.name}
                onChange={handleChange}
                list="name-suggestions"
                  required="required"
                />
                <datalist id="name-suggestions">
                  {savedData.map((item, index) => (
                    <option key={index} value={item.name} />
                  ))}
                </datalist>
            </div>
            <select onChange={handleChange}
                                className="border p-2 rounded col-8"
                                required="required"
                                name="type"
                              >
                                <option value='Outside'>Outside</option>
                                <option value='Inside'>Inside</option>
                              </select>
          </div>
          
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={handleSubmit}>Save</Button>
            {error && <p style={{ color: "red" }}>{error}</p>}
            {success && <p style={{ color: "green" }}>{success}</p>}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default LoanPOPUP;